import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { getSalesUserData } from "../../util/util";

const Header = (props) => {
  const [about, handleAbout] = useState("");
  const [packages, handlePackages] = useState("");
  const [contact, handleContact] = useState("");
  const [becomedsa, handleBecomedsa] = useState("");
  const [salesInfo, handleSalesInfo] = useState(getSalesUserData());
  const [showlogin, setShowlogin] = useState(false);

  useEffect(() => {
    handleActiveClass();
  }, []);

  const logout = () => {
    localStorage.removeItem("userInfo");
    window.location.reload();
  };
  //Handle Active class bassed on active route
  const handleActiveClass = () => {
    let url = window.location.href;
    let subUrl = url.split("/").pop();
    subUrl === "contact"
      ? handleContact("active_menu")
      : subUrl === "becomedsa"
      ? handleBecomedsa("active_menu")
      : subUrl === "about"
      ? handleAbout("active_menu")
      : subUrl === "package"
      ? handlePackages("active_menu")
      : null;
  };

  const capitalize = (str) => {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
  };

  //Return header containing link for different route.
  return (
    <div className="header_home">
      <div
        className={
          JSON.parse(localStorage.getItem("userInfo"))
            ? "yellow_bg none"
            : "yellow_bg"
        }
      >
        <img src="../../assets/images/yellow_bg.png" />
      </div>
      <div className="header_home_left">
        <div className="header_logo">
          <NavLink to="/">
            <img
              src="../../assets/images/new_logo.png"
              className="logo_white"
            />
          </NavLink>
          <NavLink to="/">
            <img
              src="../../assets/images/logo_blue.png"
              className="logo_blue"
            />
          </NavLink>
        </div>
      </div>
      <div className="header_home_right">
        <div className="header_right_menu">
          <a
            href="https://www.bigfmindia.com/"
            target="_blank"
            className="website"
          >
            BIGFM WEBSITE
          </a>
        </div>
        <div className="header_right_menu">
          <NavLink to="/about" className={about}>
            ABOUT US
          </NavLink>
        </div>
        <div className="header_right_menu">
          <NavLink to="/package" className={packages}>
            PACKAGES
          </NavLink>
        </div>

        <div className="header_right_menu">
          <NavLink to="/contact" className={contact}>
            CONTACT US
          </NavLink>
        </div>

        <div className="header_right_menu">
          <NavLink to="/tradepartner" className={becomedsa}>
            BECOME TRADE PARTNER
          </NavLink>
        </div>

        <div className="header_right_menu">
          {!salesInfo && (
            <NavLink to="/dashboard" className={name}>
              <span className="user_name">
                {JSON.parse(localStorage.getItem("userInfo"))
                  ? capitalize(
                      JSON.parse(localStorage.getItem("userInfo")).name
                    )
                  : ""}
                {JSON.parse(localStorage.getItem("userInfo"))
                  ? "'s Dashboard"
                  : ""}
              </span>
            </NavLink>
          )}
          {salesInfo && (
            <NavLink
              to="/tp/campaign"
              className={name}
              onClick={() => {
                window.location.pathname = "tp/EditKycDetails";
              }}
            >
              <span className="user_name">
                {JSON.parse(localStorage.getItem("userInfo"))
                  ? capitalize(
                      JSON.parse(localStorage.getItem("userInfo")).name
                    )
                  : ""}
                {JSON.parse(localStorage.getItem("userInfo"))
                  ? "'s Dashboard"
                  : ""}
              </span>
            </NavLink>
          )}
        </div>
        <div
          className={
            JSON.parse(localStorage.getItem("userInfo"))
              ? "header_right_menu"
              : "header_right_menu none"
          }
          onClick={logout}
        >
          <a>LOGOUT</a>
        </div>

        <div
          className={
            JSON.parse(localStorage.getItem("userInfo"))
              ? "header_right_menu none"
              : "header_right_menu"
          }
        >
          <a
            onClick={(e) => {
              setShowlogin(!showlogin);
            }}
          >
            LOGIN/SIGN UP
          </a>
          {/* <NavLink to="/login">LOGIN/SIGN UP</NavLink> */}
          {showlogin && (
            <ul className="usermenu">
              <li style={{ marginTop: "25px" }}>
                <a
                  onClick={(e) => {
                    window.location.pathname = "/login";
                  }}
                >
                  Advertiser
                </a>
              </li>
              <li style={{ marginTop: "25px" }}>
                <a
                  onClick={(e) => {
                    window.location.pathname = "tp/login";
                  }}
                >
                  Trade Partner
                </a>
              </li>
              <li style={{ marginTop: "25px" }}>
                <a
                  onClick={(e) => {
                    window.location.pathname = "admin/login";
                  }}
                >
                  Employee
                </a>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./web/components/common/Header.jsx